<template>
  <div class="subscriber">
    <div class="subscriber-channels">
      <template v-if="!!subscriber.id && (subscriber.id.length > 0)">
        <div
            class="subscriber-channel-entry"
            :class="checked ? 'active' : ''"
        >
          <channel-icon read-only :channel-data="subscriber.channel"/>
          <div class="subscriber-channel-entry__name">
            {{ subscriber.channel.label }}
          </div>
          <div class="subscriber-channel-entry__description">
            {{ subscriber.description }}
          </div>
          <div class="subscriber-channel-entry__actions">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="actionEdit === true"
                    icon
                    small
                    rounded
                    v-bind="attrs"
                    v-on="on"
                    @click="editChannelHandler(subscriber)"
                >
                  <v-icon x-small>
                    far fa-edit
                  </v-icon>
                </v-btn>
                <v-btn
                    v-if="actionAssign === true"
                    icon
                    small
                    rounded
                    v-bind="attrs"
                    v-on="on"
                    @click="assignChannelHandler"
                >
                  <v-icon x-small>
                    fas {{ checked ? 'fa-link' : 'fa-unlink' }}
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ `${actionEdit === true ? 'Edit' : checked ? 'Remove' : 'Add'} channel` }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-if="actionEdit === true"
                    icon
                    small
                    rounded
                    v-bind="attrs"
                    v-on="on"
                    @click="deleteChannelHandler(subscriber)"
                >
                  <v-icon x-small>
                    fas fa-trash
                  </v-icon>
                </v-btn>
              </template>
              <span>Delete channel</span>
            </v-tooltip>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="no-results">Tenant has no assigned subscription channels.</div>
      </template>
    </div>
  </div>
</template>

<script>
import ChannelIcon from "@/components/Settings/Tenants/ChannelIcon.vue";

export default {
  name: 'SubscriberEntry',
  components: {ChannelIcon},
  props: {
    subscriber: {
      type: Object,
      default: null
    },
    actionEdit: {
      type: Boolean,
      default: false,
    },
    actionAssign: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    /**
     * Handle the edit channel action trigger
     * @param channelData
     */
    editChannelHandler(channelData) {
      // console.log('EDIT CHANNEL TRIGGERED');
      // console.log(channelData);
      this.$emit('edit', channelData);
    },
    /**
     * Handle the delete channel action trigger
     * @param channelData
     */
    deleteChannelHandler(channelData) {
      // console.log('DELETE channel', channelData);
      this.$emit('delete', channelData);
    },
    /**
     * Handle the assign channel action trigger
     */
    assignChannelHandler() {
      // console.log('ASSIGN CHANNEL TRIGGERED');
      this.$emit('toggle');
    }
  }
}
</script>

<style lang="scss" scoped>
.subscriber-channel-entry {
  display: grid;
  grid-template-columns: 1fr 4fr 8fr 1fr;
  align-items: center;
  margin-bottom: 8px;
  padding: 4px 8px;
  transition: all ease-in-out 0.2s;

  &__actions {
    display: flex;
    justify-content: center;
    justify-self: end;
  }

  &.active {
    background-color: rgba(77, 67, 119, 0.2);
    border-left: 2px solid #685AA1;
    transition: background-color ease-in-out 0.3s;
    font-weight: 600;
    font-size: 1.2em;
  }
}

.main-dark {
  .subscriber-channel-entry {
    &:not(.active):hover {
      background-color: rgba(250, 250, 250, 0.05);
    }
  }
}

.main-light {
  .subscriber-channel-entry {
    &:not(.active):hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>